<div class="container">
    <section class="nf">
        <h1>404 – Seite nicht gefunden</h1>
        <p>Die aufgerufene Adresse existiert nicht oder wurde verschoben.</p>
        <a class="btn" href="/">Zur Startseite</a>
    </section>
</div>